import React from "react"

const Footer = () => (
  <footer>
      <p style={{textAlign: "center"}}>Copyright © {new Date().getFullYear()} Adam Richards</p>
  </footer>
)

export default Footer
